(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boxsheet-meta-lp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.documentElement.classList.add('ys-boxsheet-lp-page');

    const sizeGuideTrack = document.querySelector('.ys-boxsheet-lp__size-guide-track');
    if (sizeGuideTrack) {
      sizeGuideTrack.addEventListener('keydown', (event) => {
        const firstCard = sizeGuideTrack.querySelector('article');
        const step = firstCard ? firstCard.getBoundingClientRect().width + 16 : sizeGuideTrack.clientWidth * 0.8;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          sizeGuideTrack.scrollBy({
            left: event.key === 'ArrowRight' ? step : -step,
            behavior: 'smooth'
          });
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          sizeGuideTrack.scrollTo({
            left: event.key === 'Home' ? 0 : sizeGuideTrack.scrollWidth,
            behavior: 'smooth'
          });
        }
      });
    }

    const sticky = document.querySelector('[data-mobile-sticky]');
    const heroBuy = document.querySelector('[data-hero-buy]');
    const buyPanel = document.querySelector('[data-buy-panel]');
    const faqSection = document.querySelector('.ys-boxsheet-lp__section--faq');
    const stockSection = document.querySelector('.ys-boxsheet-lp__section--stock');
    const finalActions = document.querySelector('[data-final-actions]');
    if (sticky && heroBuy && buyPanel && faqSection && stockSection && finalActions) {
      let stickyTicking = false;
      const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      };
      const updateSticky = () => {
        const buyRect = buyPanel.getBoundingClientRect();
        const finalRect = finalActions.getBoundingClientRect();
        const shouldShow =
          buyRect.bottom <= 0 &&
          finalRect.top > 0 &&
          !isInViewport(buyPanel) &&
          !isInViewport(faqSection) &&
          !isInViewport(stockSection) &&
          !isInViewport(finalActions);
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        stickyTicking = false;
      };
      const requestStickyUpdate = () => {
        if (!stickyTicking) {
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        }
      };
      sticky.setAttribute('aria-hidden', 'true');
      updateSticky();
      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate);
      window.addEventListener('load', requestStickyUpdate, { once: true });
      document.querySelectorAll('.ys-boxsheet-lp img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', requestStickyUpdate, { once: true });
      });
    }

    const roots = document.querySelectorAll('[data-boxsheet-product]');
    roots.forEach((root) => {
      const jsonNode = root.querySelector('[data-variant-json]');
      const form = root.querySelector('form');
      if (!jsonNode || !form) return;

      const variants = JSON.parse(jsonNode.textContent);
      const selects = Array.from(root.querySelectorAll('[data-option-position]'));
      const idInput = form.querySelector('[data-variant-id]');
      const priceNode = root.querySelector('[data-variant-price]');
      const button = form.querySelector('[data-add-to-cart]');
      const buttonLabel = form.querySelector('[data-add-label]');
      const availability = form.querySelector('[data-availability]');
      const image = root.closest('.ys-boxsheet-lp__section--buy')?.querySelector('[data-variant-image]');
      const money = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });

      const updateVariant = () => {
        const selected = selects.map((select) => select.value);
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant) {
          idInput.value = '';
          button.disabled = true;
          buttonLabel.textContent = 'この組み合わせは選べません';
          availability.textContent = '別の色またはサイズをお選びください。';
          return;
        }

        idInput.value = variant.id;
        priceNode.textContent = money.format(variant.price / 100);
        button.disabled = !variant.available;
        buttonLabel.textContent = variant.available ? 'カートに追加する' : 'この組み合わせは欠品中';
        availability.textContent = variant.available
          ? 'この組み合わせは、カートへ進めます。'
          : 'ただいま欠品中です。入荷時期はLINEで確認できます。';

        if (image && variant.featured_media?.preview_image?.src) {
          image.src = variant.featured_media.preview_image.src;
          image.removeAttribute('srcset');
        }
      };

      selects.forEach((select) => select.addEventListener('change', updateVariant));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
